import cn from 'classnames';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import SectionTitle from 'UI/components/SectionTitle';
import { SwiperSlide } from 'swiper/react';
import { REVEAL_ANIMATION_PROPS } from 'utils/constants';
import { CustomYoutubePlayer } from 'components/Common/CustomYoutubePlayer';
import { getYoutubeVideoIdFromUrl } from 'utils/helper';
import { singleParams, swiperGalleryParams } from './utils/helpers';
import useSectionProps from './utils/useSectionProps';
import styles from './styles.module.scss';

const Animated = dynamic(() => import('UI/containers/Animated'));
const CustomSwiper = dynamic(() => import('UI/containers/CustomSwiper'), { ssr: false });

const YoutubeVideosSection = (props) => {
  const {
    title,
    description,
    videos,
    view,
    type,
    withSlider,
  } = useSectionProps(props);

  return (
    <section className={cn(styles.imageSection, styles[type], styles[view], {
      [styles.withSlider]: withSlider,
    })}
    >
      <div className={styles.contentWrapper}>
        <SectionTitle
          title={title}
          description={description}
          titleStyle={styles.titleStyle}
        />
        {!withSlider && (
          <div className={styles.imagesList}>
            {videos?.map((video, index) => (
              <Animated
                key={`images/${video.url}`}
                {...REVEAL_ANIMATION_PROPS}
                transitionDelay={50 * index}
              >
                <div className={styles.videoContainer}>
                  <CustomYoutubePlayer
                    src={getYoutubeVideoIdFromUrl(video.url)}
                    className={styles.video}
                  />
                  <p>{video.title}</p>
                </div>
              </Animated>
            ))}
          </div>
        )}
        {withSlider && (
          <CustomSwiper
            swiperParams={videos.length > 1 ? swiperGalleryParams : singleParams}
            className={styles.slider}
            isShowNavigation={videos.length > 1}
            navigationClassName={styles.navigation}
          >
            {videos?.map((video, i) => (
              <SwiperSlide key={`gallery-section/${i}`}>
                <div className={styles.videoContainer}>
                  <CustomYoutubePlayer
                    src={getYoutubeVideoIdFromUrl(video.url)}
                    className={styles.video}
                  />
                  <p>{video.title}</p>
                </div>
              </SwiperSlide>
            ))}
          </CustomSwiper>
        )}
      </div>
    </section>
  );
};

YoutubeVideosSection.propTypes = {
  section: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string.isRequired,
};

export default YoutubeVideosSection;
